// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Writer from "../Control.Monad.Writer/index.js";
import * as Control_Monad_Writer_Class from "../Control.Monad.Writer.Class/index.js";
import * as Control_Monad_Writer_Trans from "../Control.Monad.Writer.Trans/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Hashable from "../Data.Hashable/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map from "../Data.Map/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Elements_Keyed from "../Halogen.HTML.Elements.Keyed/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Web_HTML_Common from "../Web.HTML.Common/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Tuple.functorTuple);
var map2 = /* #__PURE__ */ Data_Functor.map(Halogen_HTML_Core.functorHTML);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var applicativeWriterT = /* #__PURE__ */ Control_Monad_Writer_Trans.applicativeWriterT(Data_Monoid.monoidArray)(Data_Identity.applicativeIdentity);
var $$for = /* #__PURE__ */ Data_Traversable["for"](applicativeWriterT)(Data_Traversable.traversableArray);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(/* #__PURE__ */ Control_Monad_Writer_Trans.bindWriterT(Data_Semigroup.semigroupArray)(Data_Identity.bindIdentity));
var tell = /* #__PURE__ */ Control_Monad_Writer_Class.tell(/* #__PURE__ */ Control_Monad_Writer_Trans.monadTellWriterT(Data_Monoid.monoidArray)(Data_Identity.monadIdentity));
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeWriterT);
var toUnfoldable1 = /* #__PURE__ */ Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Web_HTML_Common.eqClassName));
var hash = /* #__PURE__ */ Data_Hashable.hash(Data_Hashable.hashableString);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var abs = /* #__PURE__ */ Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Foldable.foldableArray);
var SheetTemplate = function (x) {
    return x;
};
var PrintedSheet = function (x) {
    return x;
};
var PrettyHash = function (x) {
    return x;
};
var StyledHTML = function (x) {
    return x;
};
var UpdateOpts = function (x) {
    return x;
};
var semigroupUpdateOpts = {
    append: function (v) {
        return function (v1) {
            return function ($99) {
                return v1(v($99));
            };
        };
    }
};
var ordPrettyHash = Data_Ord.ordString;
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ordPrettyHash)(Data_Foldable.foldableArray);
var unions = /* #__PURE__ */ Data_Map_Internal.unions(ordPrettyHash)(Data_Foldable.foldableArray);
var newtypeSheetTemplate_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePrintedSheet_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePrettyHash_ = {
    Coercible0: function () {
        return undefined;
    }
};
var monoidUpdateOpts = {
    mempty: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn),
    Semigroup0: function () {
        return semigroupUpdateOpts;
    }
};
var functorStyledHTML = {
    map: function (f) {
        return function (m) {
            return map(map1(map2(f)))(m);
        };
    }
};
var eqPrettyHash = Data_Eq.eqString;
var runHTML = function (ctx) {
    return function (v) {
        return v(ctx);
    };
};
var toHTML = function (ctx) {
    return function (stHtml) {
        var v = runHTML(ctx)(stHtml);
        var styleElems = map3(function (v1) {
            return new Data_Tuple.Tuple(unwrap(v1.value0), Halogen_HTML_Elements.style([  ])([ Halogen_HTML_Core.text(unwrap(v1.value1)) ]));
        })(toUnfoldable(v.value0));
        return [ v.value1, Halogen_HTML_Elements_Keyed.div([ Halogen_HTML_Properties.style("display: none") ])(styleElems) ];
    };
};
var withCtx = function (mkStyledHtml) {
    return function (ctx) {
        return runHTML(ctx)(mkStyledHtml(ctx));
    };
};
var runChildrenKeyed = function (ctx) {
    return function (children) {
        return Control_Monad_Writer.runWriter($$for(children)(function (v) {
            var v1 = runHTML(ctx)(v.value1);
            return discard(tell([ v1.value0 ]))(function () {
                return pure(new Data_Tuple.Tuple(v.value0, v1.value1));
            });
        }));
    };
};
var runChildren = function (ctx) {
    return function (children) {
        return Control_Monad_Writer.runWriter($$for(children)(function (styledHtml) {
            var v = runHTML(ctx)(styledHtml);
            return discard(tell([ v.value0 ]))(function () {
                return pure(v.value1);
            });
        }));
    };
};
var prettyHashToClassName = function (v) {
    return v;
};
var styleMapToClassNames = function (styleMap) {
    return map3(prettyHashToClassName)(toUnfoldable1(Data_Map.keys(styleMap)));
};
var nodeToLeaf = function (node) {
    return function (props) {
        return node(props)([  ]);
    };
};
var mkProps = function (cfg) {
    var classNames = append(cfg.extraClasses)(styleMapToClassNames(cfg.styleMap));
    var inlineStyles = Data_String_Common.joinWith(";")(cfg.inlineStyles);
    return append((function () {
        var $86 = eq(classNames)([  ]);
        if ($86) {
            return [  ];
        };
        return [ Halogen_HTML_Properties.classes(classNames) ];
    })())((function () {
        var $87 = inlineStyles === "";
        if ($87) {
            return [  ];
        };
        return [ Halogen_HTML_Properties.style(inlineStyles) ];
    })());
};
var mkPrettyHash = function (name) {
    return function (v) {
        var prefix = (function () {
            var $90 = name === "";
            if ($90) {
                return "";
            };
            return name + "-";
        })();
        var numericHash = hash(v);
        var stringHash = (function () {
            var $91 = numericHash < 0;
            if ($91) {
                return "a" + show(abs(numericHash));
            };
            return "b" + show(numericHash);
        })();
        return prefix + stringHash;
    };
};
var printStyleSheetHashed = function (uniqueIdent) {
    return function (name) {
        return function (sheetTemplate) {
            var prettyHash = mkPrettyHash(name)(sheetTemplate);
            var sheet = Data_String_Common.replaceAll(uniqueIdent)(unwrap(prettyHash))(unwrap(sheetTemplate));
            return new Data_Tuple.Tuple(prettyHash, sheet);
        };
    };
};
var scopedSheetRaw = function (replacer) {
    return function (sheetTemplate) {
        return function (opts) {
            return {
                name: opts.name,
                extraClasses: opts.extraClasses,
                inlineStyles: opts.inlineStyles,
                props: opts.props,
                context: opts.context,
                styleSheets: append(opts.styleSheets)([ printStyleSheetHashed(replacer)(opts.name)(sheetTemplate) ])
            };
        };
    };
};
var mkDefaultOpts = function (ctx) {
    return {
        name: "",
        extraClasses: [  ],
        styleSheets: [  ],
        inlineStyles: [  ],
        context: ctx,
        props: [  ]
    };
};
var leafToNode = function (leaf) {
    return function (props) {
        return function (v) {
            return leaf(props);
        };
    };
};
var inlineRaw = function (inlineStr) {
    return function (opts) {
        return {
            name: opts.name,
            extraClasses: opts.extraClasses,
            styleSheets: opts.styleSheets,
            props: opts.props,
            context: opts.context,
            inlineStyles: append(opts.inlineStyles)([ inlineStr ])
        };
    };
};
var fromHTML = function (mkHtml) {
    return function (ctx) {
        return new Data_Tuple.Tuple(Data_Map_Internal.empty, mkHtml(ctx));
    };
};
var text = function (str) {
    return fromHTML(function (v) {
        return Halogen_HTML_Core.text(str);
    });
};
var extraClasses = function (cls) {
    return function (opts) {
        return {
            name: opts.name,
            inlineStyles: opts.inlineStyles,
            styleSheets: opts.styleSheets,
            props: opts.props,
            context: opts.context,
            extraClasses: append(opts.extraClasses)(map3(Web_HTML_Common.ClassName)(cls))
        };
    };
};
var combineOpts = function (opts) {
    return function (updateOpts) {
        return foldl(function (x) {
            return function (v) {
                return v(x);
            };
        })(opts)(updateOpts);
    };
};
var styleNode = function (node) {
    return function (optsUpdates) {
        return function (props) {
            return function (children) {
                return function (ctx) {
                    var v = runChildren(ctx)(children);
                    var opts = combineOpts(mkDefaultOpts(ctx))(optsUpdates);
                    var styleMapParent = fromFoldable(opts.styleSheets);
                    var styleMap = unions(append([ styleMapParent ])(v.value1));
                    var newProps = mkProps({
                        extraClasses: opts.extraClasses,
                        styleMap: styleMapParent,
                        inlineStyles: opts.inlineStyles
                    });
                    var html = node(append(opts.props)(append(newProps)(props)))(v.value0);
                    return new Data_Tuple.Tuple(styleMap, html);
                };
            };
        };
    };
};
var styleLeaf = function (leaf) {
    return function (updateOpts) {
        return nodeToLeaf(styleNode(leafToNode(leaf))(updateOpts));
    };
};
var styleNodeKeyed = function (node) {
    return function (optsUpdates) {
        return function (props) {
            return function (children) {
                return function (ctx) {
                    var v = runChildrenKeyed(ctx)(children);
                    var opts = combineOpts(mkDefaultOpts(ctx))(optsUpdates);
                    var styleMapParent = fromFoldable(opts.styleSheets);
                    var styleMap = unions(append([ styleMapParent ])(v.value1));
                    var newProps = mkProps({
                        extraClasses: opts.extraClasses,
                        styleMap: styleMapParent,
                        inlineStyles: opts.inlineStyles
                    });
                    var html = node(append(opts.props)(append(newProps)(props)))(v.value0);
                    return new Data_Tuple.Tuple(styleMap, html);
                };
            };
        };
    };
};
export {
    PrettyHash,
    PrintedSheet,
    SheetTemplate,
    UpdateOpts,
    extraClasses,
    fromHTML,
    inlineRaw,
    scopedSheetRaw,
    styleLeaf,
    styleNode,
    styleNodeKeyed,
    text,
    toHTML,
    withCtx,
    functorStyledHTML,
    newtypePrintedSheet_,
    newtypeSheetTemplate_,
    monoidUpdateOpts,
    semigroupUpdateOpts,
    eqPrettyHash,
    ordPrettyHash,
    newtypePrettyHash_
};
//# sourceMappingURL=index.js.map
